/**
 * Created by dinesh on 21/02/17.
 */

export class WebServiceConfig {
  serverUrl: string = ''
}
;
